import { useState } from "react";
import { Monitor, Smartphone } from "lucide-react";

const clip = (s, n) => (s && s.length > n ? s.slice(0, n - 1) + "…" : s || "");

export default function SerpPreview({ title, url, description }) {
  const [mode, setMode] = useState("desktop");
  const mobile = mode === "mobile";
  const display = (url || "https://acponline.co.nz").replace(/^https?:\/\//, "");
  const crumbs = display.split("/").filter(Boolean);
  return (
    <div className="rounded-xl border bg-white p-4" data-testid="serp-preview">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Google preview</span>
        <div className="flex gap-1">
          <button onClick={() => setMode("desktop")} data-testid="serp-desktop"
            className={`flex items-center gap-1 px-2 py-1 rounded text-xs ${!mobile ? "bg-steel text-white" : "text-muted-foreground"}`}><Monitor size={13} /> Desktop</button>
          <button onClick={() => setMode("mobile")} data-testid="serp-mobile"
            className={`flex items-center gap-1 px-2 py-1 rounded text-xs ${mobile ? "bg-steel text-white" : "text-muted-foreground"}`}><Smartphone size={13} /> Mobile</button>
        </div>
      </div>
      <div className={`${mobile ? "max-w-sm" : "max-w-xl"} font-[arial]`}>
        <div className="flex items-center gap-2 mb-1">
          <span className="grid place-items-center w-6 h-6 rounded-full bg-slate-100 text-[10px] font-bold text-steel">ACP</span>
          <div className="leading-tight">
            <div className="text-[13px] text-[#202124]">ACP Online</div>
            <div className="text-[12px] text-[#4d5156]">{crumbs.join(" › ") || display}</div>
          </div>
        </div>
        <div className="text-[#1a0dab] text-[20px] leading-snug hover:underline cursor-pointer" style={{ fontFamily: "arial" }}>
          {clip(title || "Untitled page", mobile ? 58 : 60)}
        </div>
        <div className="text-[#4d5156] text-[14px] leading-snug mt-0.5">
          {clip(description || "No meta description set — Google will choose text from the page.", mobile ? 120 : 160)}
        </div>
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground">Preview only — Google may rewrite the title or snippet depending on the search query.</p>
    </div>
  );
}
